import {Component, inject, Input, OnChanges, OnInit} from '@angular/core';
import {FileUploaderService} from '../file-uploader.service';

@Component({
  selector: 'app-image-view',
  standalone: false,

  templateUrl: './image-view.component.html',
  styleUrl: './image-view.component.scss'
})
export class ImageViewComponent implements OnInit, OnChanges {
  @Input() fileKey: string;
  @Input() legacy = false;
  private uploader = inject(FileUploaderService);
  imageUrl: string;
  ngOnInit() {
    if (this.fileKey.length) {
      if (this.legacy) {
        this.getLegacyImage();
      } else {
        this.getImage();
      }
    }
  }

  ngOnChanges() {
    if (this.fileKey.length) {
      if (this.legacy) {
        this.getLegacyImage();
      } else {
        this.getImage();
      }
    } else {
      this.imageUrl = '';
    }
  }

  private getLegacyImage(): void {
    this.uploader.getSignedUrl(this.fileKey, 'GET', 300).then(url => {
      this.imageUrl = url;
    });
  }

  private getImage(): void {
    this.uploader.getSignedAssetsUrl(this.fileKey, 'GET', 300).then(url => {
      this.imageUrl = url;
    });
  }
}
